/**
 * Nutrition API client. Token comes from axios default headers (set in AuthContext).
 */
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function tz() {
  try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch { return ''; }
}

const nutritionApi = {
  getTargets: () => axios.get(`${API}/nutrition/targets`),
  patchTargets: (payload) => axios.patch(`${API}/nutrition/targets`, payload),

  parseText: (text) => axios.post(`${API}/nutrition/parse`, { text }),
  parsePhoto: (file, hint) => {
    const fd = new FormData();
    fd.append('file', file);
    if (hint) fd.append('hint', hint);
    return axios.post(`${API}/nutrition/parse-photo`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  log: (payload) => axios.post(`${API}/nutrition/log`, { ...payload, tz: tz() }),
  patchLog: (id, payload) => axios.patch(`${API}/nutrition/log/${id}`, payload),
  deleteLog: (id) => axios.delete(`${API}/nutrition/log/${id}`),

  today: () => axios.get(`${API}/nutrition/today`, { params: { tz: tz() } }),
  week: () => axios.get(`${API}/nutrition/week`, { params: { tz: tz() } }),

  /** Water / alcohol tap-tracker. kind: 'water'|'alcohol', delta ±1. */
  intake: (kind, delta = 1) => axios.post(`${API}/nutrition/intake`, { kind, delta, tz: tz() }),

  /** Set the daily water goal (ml). Stored server-side as 250ml glasses. */
  setWaterTarget: (targetMl) => axios.post(`${API}/nutrition/water-target`, { target_ml: targetMl, tz: tz() }),

  suggest: (mealType) => axios.post(`${API}/nutrition/suggest`,
    { meal_type: mealType, tz: tz() }),

  /** Auth-protected photo URL — wrap in an <img src=blobUrl/> using fetch+blob. */
  fetchPhotoBlob: async (path) => {
    const r = await axios.get(`${API}/nutrition/photo/${path}`, { responseType: 'blob' });
    return URL.createObjectURL(r.data);
  },
};

export default nutritionApi;
